import { render, staticRenderFns } from "./safeProductionDrawer.vue?vue&type=template&id=0233b1a7&scoped=true&"
import script from "./safeProductionDrawer.vue?vue&type=script&lang=js&"
export * from "./safeProductionDrawer.vue?vue&type=script&lang=js&"
import style0 from "./safeProductionDrawer.vue?vue&type=style&index=0&id=0233b1a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0233b1a7",
  null
  
)

export default component.exports